<template>
  <section>
    <div id="add-edit-lr-container" class="vx-col w-full" v-if="!savingData">
      <vx-card class="digitelex-popup-content lr-container" v-if="loadingDone">
        <form v-if="!disableadd" autocomplete="off">
          <div class="flex mb-4">
            <div class="w-3/4 px-1">
              <vx-card class="lr-card" :title="this.labelConsignmentLrNo">
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                    <vs-select
                      autocomplete
                      label="From"
                      v-validate="'required'"
                      data-vv-validate-on="input|keyup|blur|click"
                      placeholder="From"
                      name="fromBranchId"
                      v-model="frm.fromBranchId"
                      icon="arrow_downward"
                      width="100%"
                      @change="fromBranchSelected"
                      :disabled="sessionRoleId != 1 && sessionRoleId != 2"
                    >
                      <vs-select-item
                        :key="index"
                        :value="item.branchId"
                        :text="item.branchName"
                        v-for="(item, index) in branches"
                      />
                    </vs-select>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                    <vs-select
                      autocomplete
                      label="To"
                      v-validate="'required'"
                      data-vv-validate-on="input|keyup|blur|click"
                      placeholder="To"
                      label-placeholder="vs-Multiple"
                      name="toBranchId"
                      v-model="frm.toBranchId"
                      icon="arrow_downward"
                      width="100%"
                    >
                      <vs-select-item
                        :key="index"
                        :value="item.branchId"
                        :text="item.branchName"
                        v-for="(item, index) in toBranches"
                      />
                    </vs-select>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col sm:w-1/3 w-full mb-2">
                    <label>Payment Status</label>

                    <ul class="centerx digitelex-radio-group">
                      <li class="digitelex-radio-item">
                        <vs-radio
                          color="#e48346"
                          v-model="frm.consignmentPaymentStatus"
                          vs-value="1"
                          >Paid</vs-radio
                        >
                      </li>
                      <li class="digitelex-radio-item">
                        <vs-radio
                          color="#e48346"
                          v-model="frm.consignmentPaymentStatus"
                          vs-value="2"
                          >To Pay</vs-radio
                        >
                      </li>
                      <li class="digitelex-radio-item">
                        <vs-radio
                          color="#e48346"
                          v-model="frm.consignmentPaymentStatus"
                          vs-value="3"
                          >TBB</vs-radio
                        >
                      </li>
                    </ul>
                  </div>
                  <div
                    class="vx-col sm:w-1/3 w-full mb-2"
                    v-if="frm.consignmentPaymentStatus == 1"
                  >
                    <vs-select
                      autocomplete
                      label="Paid Through"
                      placeholder="Paid Through"
                      label-placeholder="vs-Multiple"
                      name="toBranchId"
                      v-model="frm.consignmentPaymentPaidThrough"
                      icon="arrow_downward"
                      width="100%"
                      @change="paidThroughtChanged()"
                    >
                      <vs-select-item key="0" value text="Select" />
                      <vs-select-item key="1" value="1" text="Cash" />
                      <vs-select-item key="2" value="2" text="Check" />
                      <vs-select-item key="3" value="3" text="DD" />
                      <vs-select-item key="4" value="4" text="Tranfer" />
                    </vs-select>
                  </div>
                  <div
                    class="vx-col sm:w-1/3 w-full mb-2"
                    v-if="showRefNo && frm.consignmentPaymentStatus == 1"
                  >
                    <vs-input
                      class="w-full"
                      placeholder="Ref No"
                      label-placeholder="Ref No"
                      name="consignmentPaymentRefNo"
                      v-model="frm.consignmentPaymentRefNo"
                    />
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                      class="w-full"
                      placeholder="Eway Bill No"
                      label-placeholder="Eway Bill No"
                      name="consignmentEwayBillNo"
                      v-model="frm.consignmentEwayBillNo"
                    />
                  </div>
                  <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                      class="w-full"
                      placeholder="Product Invoice Number"
                      label-placeholder="Product Invoice Number"
                      name="consignmentProductInvoiceNo"
                      v-model="frm.consignmentProductInvoiceNo"
                    />
                  </div>
                  <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                      class="w-full"
                      placeholder="Product Value"
                      label-placeholder="Product Value"
                      name="consignmentProductValue"
                      v-model="frm.consignmentProductValue"
                    />
                  </div>
                </div>
                <div class="vx-row clients-container">
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                    <vx-card
                      title="Consignor"
                      title-color="#fff"
                      content-color="#fff"
                      card-background="linear-gradient(120deg, #7f7fd5, #86a8e7, #91eae4)"
                    >
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/1 w-full mb-2">
                          <v-select
                            style="width: 100%"
                            taggable
                            push-tags
                            v-model="frm.consignorId"
                            name="consignorId"
                            label="clientName"
                            :options="consignorsList"
                            :reduce="(consignor) => consignor.clientId"
                            :create-option="
                              (clientName) => ({
                                address: null,
                                billingAddress: null,
                                billingName: clientName,
                                clientContactPersonMobileNo: null,
                                clientContactPersonName: clientName,
                                clientId: 0,
                                clientName: clientName,
                                clientUniq: null,
                                email: null,
                                gstNo: null,
                                isActive: true,
                                locationId: null,
                                locationName: null,
                                mobileNo: 0,
                                needEmail: 0,
                                needMessage: 0,
                                needWhatsapp: 0,
                                sendGreetings: 0,
                                zipCode: 0,
                              })
                            "
                            @option:created="createNewConsignor"
                            @option:selected="consignorSelectedOption"
                          ></v-select>
                        </div>
                      </div>
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full mb-2">
                          <vs-input
                            class="w-full"
                            placeholder="Mobile No"
                            label-placeholder="Mobile No"
                            name="consignmentConsignorMobileNo"
                            v-model="frm.consignmentConsignorMobileNo"
                          />
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-2">
                          <vs-input
                            class="w-full"
                            placeholder="GST No"
                            label-placeholder="GST No"
                            name="consignmentConsignorGstNo"
                            v-model="frm.consignmentConsignorGstNo"
                          />
                        </div>
                      </div>
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/1 w-full mb-2">
                          <label>Address</label>
                          <vs-textarea
                            v-model="frm.consignmentConsignorAddress"
                            height="200"
                            width="100%"
                            autocomplete="nope"
                          />
                        </div>
                      </div>
                    </vx-card>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                    <vx-card
                      title="Consignee"
                      title-color="#fff"
                      content-color="#fff"
                      card-background="linear-gradient(to right, #56ab2f, #a8e063)"
                    >
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/1 w-full mb-2">
                          <v-select
                            style="width: 100%"
                            taggable
                            push-tags
                            name="consigneeId"
                            v-model="frm.consigneeId"
                            label="clientName"
                            :options="consigneesList"
                            :reduce="(consignee) => consignee.clientId"
                            :create-option="
                              (clientName) => ({
                                address: null,
                                billingAddress: null,
                                billingName: clientName,
                                clientContactPersonMobileNo: null,
                                clientContactPersonName: clientName,
                                clientId: 0,
                                clientName: clientName,
                                clientUniq: null,
                                email: null,
                                gstNo: null,
                                isActive: true,
                                locationId: null,
                                locationName: null,
                                mobileNo: 0,
                                needEmail: 0,
                                needMessage: 0,
                                needWhatsapp: 0,
                                sendGreetings: 0,
                                zipCode: 0,
                              })
                            "
                            @option:created="createNewConsignee"
                            @option:selected="consigneeSelectedOption"
                          ></v-select>
                        </div>
                      </div>
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full mb-2">
                          <vs-input
                            class="w-full consignee-details-text-color"
                            placeholder="Mobile No"
                            label-placeholder="Mobile No"
                            name="consignmentConsigneeMobileNo"
                            v-model="frm.consignmentConsigneeMobileNo"
                          />
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-2">
                          <vs-input
                            class="w-full"
                            placeholder="GST No"
                            label-placeholder="GST No"
                            name="consignmentConsigneeGstNo"
                            v-model="frm.consignmentConsigneeGstNo"
                          />
                        </div>
                      </div>
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/1 w-full mb-2">
                          <label>Address</label>
                          <vs-textarea
                            v-model="frm.consignmentConsigneeAddress"
                            height="200"
                            width="100%"
                            autocomplete="nope"
                          />
                        </div>
                      </div>
                    </vx-card>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                    <div class="flex justify-between font-semibold mb-3">
                      <span>Total</span>
                      <span>{{ frm.consignmentTotalCharge }}</span>
                    </div>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                    <vs-input
                      class="w-full"
                      placeholder="CGST (%)"
                      label-placeholder="CGST (%)"
                      name="consignmentCGstCharge"
                      v-model="frm.consignmentCGstCharge"
                    />
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full mb-2"></div>
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                    <vs-input
                      class="w-full"
                      placeholder="SGST (%)"
                      label-placeholder="SGST (%)"
                      name=" consignmentSGstCharge"
                      v-model="frm.consignmentSGstCharge"
                    />
                  </div>
                </div>
                <div class="flex justify-between font-semibold mb-3">
                  <span>Total</span>
                  <span>{{ frm.consignmentGrandTotalCharge }}</span>
                </div>
              </vx-card>
            </div>
            <div class="w-1/4 px-1">
              <vx-card class="lr-card consignement-package" title="Add Package">
                <div class="vx-row">
                  <div class="vx-col sm:w-1/1 w-full mb-1">
                    <vs-select
                      class="Location"
                      label="Consignement Type"
                      v-validate="'required'"
                      data-vv-validate-on="input|keyup|blur|click"
                      placeholder="Consignement Type"
                      label-placeholder="vs-Multiple"
                      v-model="currentConsignementData.consignmentPackageTypeId"
                      width="100%"
                      autocomplete
                    >
                      <vs-select-item
                        :key="index"
                        :value="item.consignmentTypeId"
                        :text="item.consignmentTypeName"
                        v-for="(item, index) in consignementTypesList"
                      />
                    </vs-select>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      class="w-full"
                      v-validate="'required|digits:2'"
                      placeholder="Quantity"
                      autocomplete="off"
                      label-placeholder="Quantity"
                      name="CurrentConsignmentPackageQuantity"
                      v-model="
                        currentConsignementData.consignmentPackageQuantity
                      "
                    />
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      class="w-full"
                      placeholder="Total Weight (kg)"
                      label-placeholder="Total Weight (kg)"
                      name="currentConsignmentPackageWeight"
                      v-model="currentConsignementData.consignmentPackageWeight"
                      autocomplete="off"
                    />
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col sm:w-1/1 w-full">
                    <label>Description</label>
                    <vs-textarea
                      v-model="
                        currentConsignementData.consignmentPackageComment
                      "
                      height="150"
                      width="100%"
                      autocomplete="nope"
                    />
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input
                      autocomplete="off"
                      class="w-full"
                      v-validate="'digits:6'"
                      placeholder="Length"
                      label-placeholder="Length"
                      name="CurrentConsignmentPackageLength"
                      v-model="currentConsignementData.consignmentPackageLength"
                    />
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input
                      autocomplete="off"
                      class="w-full"
                      v-validate="'digits:6'"
                      placeholder="Width"
                      label-placeholder="Width"
                      name="currentConsignmentPackageWidth"
                      v-model="currentConsignementData.consignmentPackageWidth"
                    />
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input
                      class="w-full"
                      v-validate="'digits:6'"
                      autocomplete="off"
                      placeholder="Height"
                      label-placeholder="Height"
                      name="currentConsignmentPackageHeight"
                      v-model="currentConsignementData.consignmentPackageHeight"
                    />
                  </div>
                  <div class="vx-row" v-if="frm.consignmentPaymentStatus == 1">
                    <div class="vx-col sm:w-1/2 w-full">
                      <vs-input
                        class="w-full"
                        placeholder="Cost per Kg"
                        label-placeholder="Cost per Kg"
                        name="consignmentPackageCostperKg"
                        v-model="
                          currentConsignementData.consignmentPackageCostperKg
                        "
                        @keyup="packageCostUpdate"
                      />
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                      <vs-input
                        class="w-full"
                        disabled
                        placeholder="Package Total Cost"
                        label-placeholder="Package Total Cost"
                        name="consignmentPackageTotalCost"
                        v-model="
                          currentConsignementData.consignmentPackageTotalCost
                        "
                      />
                    </div>
                  </div>
                </div>
                <div class="flex flex-wrap justify-end mt-1">
                  <vs-button
                    :disabled="!validateForm"
                    @click="savePackage"
                    v-if="frm.consignmentStatus != 5"
                    class="ml-auto"
                    >{{
                      currentConsignementData.consignmentPackageId != 0
                        ? "Update"
                        : "Add"
                    }}
                  </vs-button>
                </div>
              </vx-card>
              <vx-card class="lr-card mt-1" title="Charges">
                <div class="vx-row">
                  <div class="vx-col sm:w-1/1 w-full">
                    <vs-input
                      class="w-full"
                      placeholder="Frieght"
                      label-placeholder="Frieght"
                      name="consignmentFreightCharge"
                      v-model="frm.consignmentFreightCharge"
                    />
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      class="w-full"
                      placeholder="Hamali"
                      label-placeholder="Hamali"
                      name="consignmentHamaliCharge"
                      @keyup="updateFrieght()"
                      v-model="frm.consignmentHamaliCharge"
                    />
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      class="w-full"
                      placeholder="Stationary"
                      label-placeholder="Stationary"
                      name="consignmentStationaryCharge"
                      @keyup="updateFrieght()"
                      v-model="frm.consignmentStationaryCharge"
                    />
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      class="w-full"
                      placeholder="Unloading"
                      label-placeholder="Unloading"
                      name="consignmentUnloadingCharge"
                      v-model="frm.consignmentUnloadingCharge"
                      @keyup="updateFrieght()"
                    />
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      class="w-full"
                      placeholder="LR"
                      label-placeholder="LR"
                      name="consignmentLrCopyCharge"
                      v-model="frm.consignmentLrCopyCharge"
                      @keyup="updateFrieght()"
                    />
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      class="w-full"
                      placeholder="Door Delivery"
                      label-placeholder="Door Delivery"
                      name="consignmentDoorDeliveryCharge"
                      v-model="frm.consignmentDoorDeliveryCharge"
                      @keyup="updateFrieght()"
                    />
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      class="w-full"
                      placeholder="Other"
                      label-placeholder="Other"
                      name="consignmentOtherCharge"
                      v-model="frm.consignmentOtherCharge"
                      @keyup="updateFrieght()"
                    />
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
          <div class="flex mb-4">
            <vx-card class="lr-card" :title="'Consignement Packges'">
              <vs-table max-items="3" pagination :data="frm.packages">
                <template slot="thead">
                  <vs-th>S No</vs-th>
                  <vs-th>Consignment Type</vs-th>
                  <vs-th>Quantity</vs-th>
                  <vs-th>Length</vs-th>
                  <vs-th>Height</vs-th>
                  <vs-th>Weight</vs-th>
                  <vs-th>Description</vs-th>
                  <vs-th>Total Weight (Kgs)</vs-th>
                  <vs-th>Actions</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ indextr + 1 }}</vs-td>
                    <vs-td :data="data[indextr].consignmentPackageTypeId">{{
                      getContentTypeName(data[indextr].consignmentPackageTypeId)
                    }}</vs-td>

                    <vs-td :data="data[indextr].consignmentPackageQuantity">{{
                      data[indextr].consignmentPackageQuantity
                    }}</vs-td>
                    <vs-td :data="data[indextr].consignmentPackageLength">{{
                      data[indextr].consignmentPackageLength
                    }}</vs-td>
                    <vs-td :data="data[indextr].consignmentPackageWidth">{{
                      data[indextr].consignmentPackageWidth
                    }}</vs-td>

                    <vs-td :data="data[indextr].consignmentPackageHeight">{{
                      data[indextr].consignmentPackageHeight
                    }}</vs-td>

                    <vs-td :data="data[indextr].consignmentPackageComment">{{
                      data[indextr].consignmentPackageComment
                    }}</vs-td>

                    <vs-td :data="data[indextr].consignmentPackageWeight">{{
                      data[indextr].consignmentPackageWeight
                    }}</vs-td>
                    <vs-td :data="data[indextr].consignmentPackageWeight">
                      <div class="flex">
                        <vs-button
                          v-if="frm.consignmentStatus != 5"
                          @click="
                            editPackage(
                              data[indextr].consignmentPackageId,
                              indextr
                            )
                          "
                          type="border"
                          size="small"
                          icon-pack="feather"
                          icon="icon-edit"
                          class="mr-2"
                        ></vs-button>
                        <vs-button
                          v-if="frm.consignmentStatus != 5"
                          @click="
                            deletePackage(
                              data[indextr].consignmentPackageId,
                              indextr
                            )
                          "
                          type="border"
                          size="small"
                          icon-pack="feather"
                          icon="icon-trash"
                          color="danger"
                          class="mr-2"
                        ></vs-button>
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
          </div>
          <div class="flex mb-4">
            <vx-card class="lr-card" :title="'Comments'">
              <vs-textarea
                v-model="frm.consignmentComment"
                counter="2000"
                label="Comment"
                :counter-danger.sync="counterDanger"
              />
            </vx-card>
          </div>
        </form>
        <div v-else-if="disableadd">
          <vx-card
            :title="this.disableMessages.staticMessage"
            title-color="#fff"
            content-color="#fff"
            card-background="linear-gradient(120deg, #7f7fd5, #86a8e7, #91eae4)"
          >
            <p class="mb-3">
              <strong
                >For More Details :
                {{ this.disableMessages.dynamicMessage }}</strong
              >
            </p>
          </vx-card>
        </div>
      </vx-card>
      <p v-if="!loadingDone">Loading ...</p>
      <div class="flex flex-wrap justify-end mt-2">
        <vs-button
          :disabled="!validateMain"
          @click="saveLr"
          class="ml-auto"
          v-if="frm.consignmentStatus != 5"
          >Save</vs-button
        >
        <!-- <vs-button class="ml-4" type="border" color="warning">Cancel</vs-button> -->
      </div>
    </div>
    <p v-if="savingData">Saving</p>
  </section>
</template>
<script>
import { Validator } from "vee-validate";
import vSelect from "vue-select";

const dict = {
  custom: {
    clientName: {
      required: "Please enter your first name",
      alpha: "Your first name may only contain alphabetic characters",
    },
  },
};

Validator.localize("en", dict);

export default {
  props: {
    frmData: {},
  },
  components: {
    "v-select": vSelect,
  },
  methods: {
    paidThroughtChanged() {
      if (this.frm.consignmentPaymentPaidThrough > 1) {
        this.showRefNo = true;
      } else {
        this.showRefNo = false;
      }
    },
    deletePackage(_id, index) {
      alert("Delete Package");
      this.frm.packages.splice(index, 1);
    },
    editPackage(_id, index) {
      console.log("Edit Package");
      this.currentConsignementData = this.frm.packages[index];
      this.frm.packages.splice(index, 1);
    },
    saveLr() {
      this.savingData = true;

      if (this.frm.consignmentId) {
        //Update Consignment
        this.frm.isActive = true;
        if (this.frm.additionalComments.length <= 0) {
          this.frm.additionalComments = [];
          this.$http
            .put("portage/lr", this.frm)
            .then((response) => {
              console.log(response);
              this.savingData = false;
              this.$emit("submitResponse", response);
            })
            .catch((error) => {
              this.savingData = false;
              console.log(error);
              alert(error.response.data.message);
            });
        }
      } else {
        //Add Consignment
        this.frm.isActive = true;
        this.frm.consignmentId = 0;
        console.log(this.frm);
        if (this.frm.additionalComments.length <= 0) {
          this.frm.additionalComments = [];
        }
        this.$http
          .post("portage/lr", this.frm)
          .then((response) => {
            this.savingData = false;
            console.log(response);
            this.$emit("submitResponse", response);
          })
          .catch((error) => {
            alert(error.response.data.message);
            console.log(error);
          });
      }
    },
    getBranches() {
      this.$http.get("common/branches").then((response) => {
        this.branches = response.data.data;
        this.toBranches = this.branches.filter((branch) => {
          return branch.branchId != this.frm.fromBranchId;
        });
        // this.$vs.loading.close("#add-edit-branch-container > .con-vs-loading");
      });
    },
    fromBranchSelected() {
      // alert(this.frm.fromBranchId);
      this.getLrNo();
      this.toBranches = this.branches.filter((branch) => {
        return branch.branchId != this.frm.fromBranchId;
      });
    },
    getClients() {
      this.$http.get("portage/clients").then((response) => {
        this.allClients = response.data.data;
        this.consignorsList = this.allClients;
        this.consigneesList = this.allClients.filter((client) => {
          return client.clientId != this.frm.consignorid;
        });
        console.log(this.consigneesList);
        // this.$vs.loading.close("#add-edit-branch-container > .con-vs-loading");
      });
    },
    createNewConsignor(e) {
      console.log(e);
    },
    createNewConsignee(e) {
      console.log(e);
    },
    consignorSelectedOption(e) {
      this.frm.consignor = e;
      this.frm.consignmentConsignorMobileNo = this.frm.consignor.mobileNo;
      this.frm.consignmentConsignorGstNo = this.frm.consignor.gstNo;
      this.frm.consignmentConsignorAddress = this.frm.consignor.address;
      this.frm.consignorId = this.frm.consignor.clientId;
      this.consigneesList = this.allClients.filter((client) => {
        return client.clientId != this.frm.consignorId;
      });
    },
    consigneeSelectedOption(e) {
      this.frm.consignee = e;
      this.frm.consignmentConsigneeMobileNo = this.frm.consignee.mobileNo;
      this.frm.consignmentConsigneeGstNo = this.frm.consignee.gstNo;
      this.frm.consignmentConsigneeAddress = this.frm.consignee.address;
      this.frm.consigneeId = this.frm.consignee.clientId;
    },
    getConsignementType() {
      this.$http.get(`common/consignmentTypes`).then((response) => {
        this.consignementTypesList = response.data.data;
      });
    },
    getContentTypeName(id) {
      if (this.consignementTypesList.length > 0) {
        const consignment = this.consignementTypesList.find(
          (el) => el.consignmentTypeId == id
        );
        return consignment.consignmentTypeName;
      }
      return "";
    },
    packageCostUpdate() {
      if (this.currentConsignementData.consignmentPackageWeight) {
        this.currentConsignementData.consignmentPackageTotalCost =
          parseInt(this.currentConsignementData.consignmentPackageWeight, 10) *
          parseInt(
            this.currentConsignementData.consignmentPackageCostperKg,
            10
          );
      } else {
        alert("Please Provide the Package Weight");
      }
    },
    savePackage() {
      if (this.frm.packages.length == 0) {
        this.frm.packages = [];
      }
      if (this.currentConsignementData.consignmentPackageWeight > 0) {
        if (this.frm.consignmentPaymentStatus == 1) {
          if (
            this.currentConsignementData.consignmentPackageCostperKg != null &&
            this.currentConsignementData.consignmentPackageCostperKg !== 0 &&
            this.currentConsignementData.consignmentPackageCostperKg != ""
          ) {
            this.currentConsignementData.consignmentPackageTotalCost =
              parseInt(
                this.currentConsignementData.consignmentPackageWeight,
                10
              ) *
              parseInt(
                this.currentConsignementData.consignmentPackageCostperKg,
                10
              );
            this.frm.packages.push(this.currentConsignementData);
            this.frm.consignmentFreightCharge =
              this.frm.consignmentFreightCharge +
              this.currentConsignementData.consignmentPackageTotalCost;

            this.currentConsignementData = {
              consignmentPackageId: 0,
              consignmentPackageTypeId: null,
              consignmentPackageComment: null,
              consignmentPackageQuantity: null,
              consignmentPackageWeight: null,
              consignmentPackageLength: null,
              consignmentPackageWidth: null,
              consignmentPackageHeight: null,
              consignmentPackageCostperKg: null,
              consignmentPackageTotalCost: null,
            };
          } else {
            // this.$vs.notify({
            //   title: "Error",
            //   text: "Please enter valid details",
            //   color: "warning",
            //   iconPack: "feather",
            //   icon: "icon-alert-circle",
            // });
            alert("Please Enter Cost per kg becuase its a paid booking");
            return false;
          }
        } else {
          this.frm.packages.push(this.currentConsignementData);
          this.currentConsignementData = {
            consignmentPackageId: 0,
            consignmentPackageTypeId: null,
            consignmentPackageComment: null,
            consignmentPackageQuantity: null,
            consignmentPackageWeight: null,
            consignmentPackageLength: null,
            consignmentPackageWidth: null,
            consignmentPackageHeight: null,
            consignmentPackageCostperKg: null,
            consignmentPackageTotalCost: null,
          };
        }
        this.frm.consignmentTotalCharge =
          parseInt(this.frm.consignmentFreightCharge, 10) +
          parseInt(this.frm.consignmentHamaliCharge, 10) +
          parseInt(this.frm.consignmentStationaryCharge, 10) +
          parseInt(this.frm.consignmentSurCharge, 10) +
          parseInt(this.frm.consignmentUnloadingCharge, 10) +
          parseInt(this.frm.consignmentLrCopyCharge, 10) +
          parseInt(this.frm.consignmentDoorDeliveryCharge, 10) +
          parseInt(this.frm.consignmentOtherCharge, 10);
        console.log(this.frm.packages);
        this.consignmentGrandTotalCharge = this.frm.consignmentTotalCharge;
      } else {
        alert("Please Enter Consignemt Type,Weight and Quntity");
      }
    },
    updateFrieght() {
      this.frm.consignmentTotalCharge =
        (parseInt(this.frm.consignmentFreightCharge, 10) || 0) +
        (parseInt(this.frm.consignmentHamaliCharge, 10) || 0) +
        (parseInt(this.frm.consignmentStationaryCharge, 10) || 0) +
        (parseInt(this.frm.consignmentSurCharge, 10) || 0) +
        (parseInt(this.frm.consignmentUnloadingCharge, 10) || 0) +
        (parseInt(this.frm.consignmentLrCopyCharge, 10) || 0) +
        (parseInt(this.frm.consignmentDoorDeliveryCharge, 10) || 0) +
        (parseInt(this.frm.consignmentOtherCharge, 10) || 0);
      this.consignmentGrandTotalCharge = this.frm.consignmentTotalCharge;
    },
    getLrNo() {
      this.$http
        .get(`portage/consignmentSerialNo/${this.frm.fromBranchId}/1`)
        .then((response) => {
          if (response.data.serialNo != 0) {
            //alert(response.data.serialNo);
            this.queryLrNo = response.data.serialNo;
            this.labelConsignmentLrNo = `LR No ${this.queryLrNo}`;
            this.frm.consignmentLrNo = this.queryLrNo;
            this.frm.consignmentHamaliCharge = 0;
            this.frm.consignmentStationaryCharge = 0;
            this.frm.consignmentSurCharge = 0;
            this.frm.consignmentUnloadingCharge = 0;
          } else {
            this.disableadd = true;
            this.disableMessages.dynamicMessage = response.data.message;
          }
          this.loadingDone = true;
          console.log(this.vehiclesList);
          // this.getBranchTypes();
        });
    },
  },
  data() {
    return {
      loadingDone: false,
      savingData: false,
      branchTypeEnum: [],
      allClients: [],
      branches: [],
      toBranches: [],
      consignorsList: [],
      consigneesList: [],
      consignementTypesList: [],
      labelConsignmentLrNo: null,
      counterDanger: false,
      queryLrNo: null,
      disableadd: false,
      showRefNo: false,
      disableMessages: {
        staticMessage: "Uable to Add LR! Please contact Admin",
        dynamicMessage: "",
      },

      sessionRoleId: JSON.parse(localStorage.getItem("sstUnData")).roles[0]
        .roleId,
      currentConsignementData: {
        consignmentPackageId: 0,
        consignmentPackageTypeId: null,
        consignmentPackageComment: null,
        consignmentPackageQuantity: null,
        consignmentPackageWeight: null,
        consignmentPackageLength: null,
        consignmentPackageWidth: null,
        consignmentPackageHeight: null,
        consignmentPackageCostperKg: null,
        consignmentPackageTotalCost: null,
      },
      currentAddtionalCommentsData: {
        conginmentAddtionalCommentId: 0,
        conginmentAddtionalCommentShortNote: null,
        conginmentAddtionalCommentText: null,
        conginmentAddtionalVisibleInLr: null,
      },
      frm: {
        isActive: true,
        consignmentLrNo: null,
        fromBranchId: null,
        toBranchId: null,
        consignmentId: null,
        consignmentPaymentStatus: null,
        consignmentEwayBillNo: null,
        consignmentProductValue: null,
        consignmentProductInvoiceNo: null,
        consignmentPaymentPaidThrough: null,
        consignmentPaymentRefNo: null,
        consignorId: null,
        consignmentConsignorMobileNo: null,
        consignmentConsignorGstNo: null,
        consignmentConsignorAddress: null,
        consigneeId: null,
        consignmentConsigneeMobileNo: null,
        consignmentConsigneeGstNo: null,
        consignmentConsigneeAddress: null,
        packages: [],
        additionalComments: [],
        consignor: {},
        consignee: {},
        consignmentFreightCharge: 0,
        consignmentHamaliCharge: 0,
        consignmentStationaryCharge: 0,
        consignmentSurCharge: 0,
        consignmentUnloadingCharge: 0,
        consignmentLrCopyCharge: 0,
        consignmentDoorDeliveryCharge: 0,
        consignmentOtherCharge: 0,
        consignmentTotalCharge: 0,
        consignmentCGstCharge: 0,
        consignmentSGstCharge: 0,
        consignmentGrandTotalCharge: 0,
        consignmentComment: null,
        consignmentStatus: 0,
      },
    };
  },
  watch: {
    frmData: {
      handler(after) {
        this.frm = after;
        console.log(this.frm);
        // alert(this.frm.consignmentLrNo);
        // console.log(this.frm.consignmentLrNo);
        if (
          (!this.frm.consignmentLrNo && this.frm.consignmentLrNo.length <= 0) ||
          this.frm.consignmentLrNo == ""
        ) {
          this.getLrNo();
        } else {
          this.loadingDone = true;
          //No
          this.labelConsignmentLrNo = `LR No ${this.frm.consignmentLrNo}`;

          console.log(this.frm);
        }

        // this.vehicleDropDown = this.frm.pVehicleId;
      },
      immediate: true,
    },
  },

  computed: {
    validateMain() {
      return (
        this.frm.consignor != "" &&
        this.frm.consignor != null &&
        this.frm.consignee != "" &&
        this.frm.consignee != null &&
        this.frm.consigneeId != null &&
        this.frm.consignorId != null &&
        this.frm.packages.length >= 1
      );
    },
    validateForm() {
      return (
        this.currentConsignementData.consignmentPackageTypeId != null &&
        this.currentConsignementData.consignmentPackageTypeId != 0 &&
        this.currentConsignementData.consignmentPackageTypeId != "" &&
        this.currentConsignementData.consignmentPackageQuantity != null &&
        this.currentConsignementData.consignmentPackageQuantity != "" &&
        this.currentConsignementData.consignmentPackageQuantity != 0 &&
        this.currentConsignementData.consignmentPackageWeight != null &&
        this.currentConsignementData.consignmentPackageWeight != "" &&
        this.currentConsignementData.consignmentPackageWeight != 0
      );
    },
  },
  beforeMount() {
    // this.getVehicles();
    this.getBranches();
    this.getClients();
    this.getConsignementType();
  },
};
</script>
<style scoped>
.lr-card .vx-card__header {
  padding: 1rem 1rem 0 !important;
}
.lr-container .vx-card__body {
  padding: 1.5rem 1rem !important;
}
.digitelex-radio-item {
  display: inline-block;
  padding: 10px;
  margin-top: 5px;
}
.consignement-package > .vx-card__body {
  padding: 8px !important;
}
</style>
<style>
input[name="consignmentConsigneeMobileNo"],
input[name="consignmentConsignorMobileNo"],
input[name="consignmentConsignorGstNo"],
input[name="consignmentConsigneeGstNo"] {
  color: white !important;
  background: transparent;
}

div[name="consigneeId"] .vs__selected,
div[name="consignorId"] .vs__selected {
  color: white !important;
}
.clients-container .vx-card__body {
  padding: 0.8rem !important;
}
</style>
  